import instagram from './Image/instagram.png';
import facebook from './Image/facebook.png'
import { Link} from 'react-scroll';
import snaptchat from './Image/snapchat.png';


export const Header = () => {

    function InstLink () {
        const instLink = 'https://instagram.com/barber.malek?igshid=MzRlODBiNWFlZA==';
        window.open(instLink);
    }

    function FaceLink () {
        const FaceBookLink = 'https://www.facebook.com/barbermalek/';
        window.open(FaceBookLink);
    }

    function SnapLink () {
        const FaceBookLink = 'https://t.snapchat.com/85CJPo2V';
        window.open(FaceBookLink);
    }


    return (
       <section id="here">
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <h1>Dreaming of a space dedicated to style and comfort? Welcome to Barber Malek</h1>
                    <p>One location, endless experiences.</p>
                    <Link to="about" id="btn-brand">Get in touch</Link>
                    <div id='bl-icon'>
                        <img src={instagram} alt="inst" className='icon' onClick={InstLink}/>
                        <img src={facebook} alt="facebook" className='icon' onClick={FaceLink}/>
                        <img src={snaptchat} alt="facebook" className='icon' onClick={SnapLink}/>
                    </div>
                </div>
            </div>

            
        </div>
       </section>
    );
}